export default __webpack_public_path__ + "decoderWorker.min.wasm";